import { Heading } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import React, { useEffect } from 'react'
import { BackLink, Head } from '../../../src/component'
import { CreateAccount } from '../../component/CreateAccount'
import { Route } from '../../../src/config/router'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'
import { useAppRouter } from '../../../src/state'

export const SignUpPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const heading = t('signUp:heading')
  const pageTitle = `${t('common:brandName')} | ${heading}`

  useEffect(() => {
    router.prefetch(Route.VERIFY)
    router.prefetch(Route.TERMINAL_ERROR)
  }, [])

  return (
    <>
      <Head title={pageTitle} />
      <BackLink backTo={Route.ENTER_EMAIL} />
      <Heading size='XL'>{heading}</Heading>
      <CreateAccount />
      <TrackPageViewed />
    </>
  )
}
